import { styled } from "@mui/material";

// export const ProfileImageContainer = styled("div")(({ theme }) => ({
//   width: "40%",
//   height: "100%",
//   display: "grid",
//   placeItems: "center",
//   [theme.breakpoints.down("lg")]: {
//     width: "50%",
//   },
//   [theme.breakpoints.down("md")]: {
//     width: "100%",
//     height: "50%",
//   },
//   // backgroundColor:'red'
// }));

export const ProfileImage = styled("div")(({ url, theme }) => ({
  width: "300px",
  height: "300px",
  borderRadius: "100%",
  position: "absolute",
  backgroundImage: `url('${url}')`,
  backgroundPosition: "center",
  backgroundSize: "cover",
  border: "1px solid white",
  [theme.breakpoints.down("lg")]: {
    width: "280px",
    height: "280px",
  },
  [theme.breakpoints.down("md")]: {
    width: "250px",
    height: "250px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "200px",
    height: "200px",
  },
}));

export const IntroImageContainer = styled("div")(({ theme }) => ({
  width: "600px",
  height: "600px",
  display: "grid",
  placeItems: "center",
  [theme.breakpoints.down("lg")]: {
    width: "550px",
    height: "550px",
  },
  [theme.breakpoints.down("md")]: {
    width: "500px",
    height: "500px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "400px",
    height: "400px",
  },
}));
